import * as React from "react"
import ReactDatePicker from "react-datepicker";
import {IPatientNotesOOC} from "../../components/patient/PatientNotesOOCCard";
import TextareaAutosize from "react-autosize-textarea/lib/TextareaAutosize";
import {Modal} from "react-bootstrap";
import {IAppState} from "../../models/IAppState";
import IDoctorProfile from "../../models/IDoctorProfile";
import {connect} from "react-redux";
import * as moment from "moment";;
import {get as _get} from "lodash"
import {default as CTA, CTATheme} from "../common/CallToAction";

export interface AddPatientNotesOOCModalProps {
    savePatientNotesOOC: any
    show: boolean,
    onHide: any,
}

export interface AddPatientNotesOOCModalState {
    patientNotesOOC: IPatientNotesOOC,
}

class AddPatientNotesOOCModal extends React.Component<AddPatientNotesOOCModalProps & IStateProps, AddPatientNotesOOCModalState> {
    constructor(props: AddPatientNotesOOCModalProps & IStateProps) {
        super(props)
        this.state = this.getStateFromProps()
    }

    getStateFromProps() {
        return {
            patientNotesOOC: {
                notes: "",
                recordedDate: new Date(),
                doctorName: _get(this.props, "doctorProfile.prefix", "") + " " + _get(this.props, "doctorProfile.name"),
                tenant: _get(this.props, "doctorProfile.tenant")
            }
        }
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.show !== this.props.show) {
            this.setState(this.getStateFromProps())
        }
    }

    onNotesChange = (e: any) => {
        this.setState({
            patientNotesOOC: {
                ...this.state.patientNotesOOC,
                notes: e.target.value
            }
        })
    }

    onDateChange = (date: any) => {
        this.setState({
            patientNotesOOC: {
                ...this.state.patientNotesOOC,
                recordedDate: date,
            }
        })
    }


    onSave = () => {
        this.props.savePatientNotesOOC(this.state.patientNotesOOC)
    }

    render() {

        return <div>
            <Modal onHide={this.props.onHide} show={this.props.show} className={"add-patient-notes-ooc-modal"}>
                <Modal.Header closeButton className={"add-patient-notes-ooc-modal-header"}>
                    <Modal.Title id='ModalHeader'>Private Notes For {this.props.patientName}</Modal.Title>
                </Modal.Header>
                <Modal.Body className={"add-patient-notes-ooc-modal-body"}>
                    <TextareaAutosize className={"add-patient-notes-ooc-modal-text-area"} onChange={this.onNotesChange}
                                      rows={5} placeholder={"Eg. anything that will be helpful to the next doctor"}/>
                    <div className={"add-patient-notes-ooc-modal-date-picker"}>
                        <ReactDatePicker
                            selected={moment(this.state.patientNotesOOC.recordedDate)}
                            onChange={this.onDateChange}
                            dateFormat={"Do MMM, YYYY"}
                            maxDate={new Date()}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className={"add-patient-notes-ooc-modal-footer"}>
                    <CTA innerText={"Save Note"} theme={CTATheme.PRIMARY} onClick={this.onSave} customStyle={{width: 120, margin: "10px auto"}} />
                </Modal.Footer>
            </Modal>
        </div>
    }
}

interface IStateProps {
    doctorProfile: IDoctorProfile,
    patientName: string
}

const mapStateToProps = (state: IAppState): IStateProps => {
    return {
        doctorProfile: state.doctorProfile,
        patientName: _get(state, "patientCompleteInfo.profile.name", "")
    }

}

export default connect<IStateProps, void, AddPatientNotesOOCModalProps>(mapStateToProps, null)(AddPatientNotesOOCModal)